import Swiper, {Pagination, Lazy, Parallax, Autoplay} from "swiper";

export default function frontpage() {
    Swiper.use([Pagination, Lazy, Parallax, Autoplay]);
    const swiper = new Swiper('.frontpage-slider__swiper', {
        speed: 800,
        loop: true,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        preloadImages: true,
        lazy: {
            loadPrevNext: true,
        },
        parallax: true,
        pagination: {
            el: ".frontpage-slider__pagination",
            clickable: true
        },
    });
}
